import { render, staticRenderFns } from "./Notify.vue?vue&type=template&id=57221a72&"
import script from "./Notify.vue?vue&type=script&lang=js&"
export * from "./Notify.vue?vue&type=script&lang=js&"
import style0 from "./Notify.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports